// LoginPage - usa el componente de login v1 directamente
import { Login } from '../modules/security/pages/login/Login.page';

export const LoginPage = () => <Login />;

export default LoginPage;
